/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpsInterceptorService } from './https-interceptor.service';
import { ErrorInterceptorService } from './error-interceptor.service';
import { JwtInterceptorService } from './jwt-interceptor.service';

/** Http interceptor providers in outside-in order */
export const HttpInterceptors = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpsInterceptorService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptorService, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
];
